import {EsimPackage} from '@chekin/core';
import {FormTypes} from '../ChooseForm/types';

export const getPrice = (esimPackage: EsimPackage, count: number = 1) => {
  return (Number(esimPackage.package_price) * count).toFixed(2);
};

export const getTotalPrice = (esimPackages: EsimPackage[]) => (values: FormTypes) => {
  return esimPackages.reduce((acc, esimPackage) => {
    if (values[esimPackage.package_id]?.checked) {
      return (
        acc +
        Number(esimPackage.package_price) * (values[esimPackage.package_id]?.count || 1)
      );
    }
    return acc;
  }, 0);
};

export const hasItems = (esimPackages: EsimPackage[]) => (values: FormTypes) => {
  return esimPackages.some(esimPackage => values[esimPackage.package_id]?.checked);
};
